// extracted by mini-css-extract-plugin
export default {"cls1":"cdgYyfnhZF4Q4XAKLbKb","cls2":"KG10zTQyhrSVbyCnrqMq cdgYyfnhZF4Q4XAKLbKb"};